<template>
    <el-container>
        <el-row style="width: 100%" v-if="has_permission('view:admin_dashboard')" >
            <!--左边-->
            <el-col :lg="18" :sm="24">
                <el-row>
                    <el-col :lg="6" :xs="12" class="topCard_view">
                        <el-card class="topCard" shadow="hover" v-loading="fourCard.order.is_loading">
                            <el-popover
                                placement="top"
                                width="200"
                                trigger="hover"
                                >
                                <p>{{fourCard.order.message}}</p>
                                <div slot="reference">
                                    <div class="cardHeader">
                                        <span class="top_title">计划数</span>
                                        <el-dropdown style="position: absolute;top: 10px;right: 15px" @command="handleCommand($event,'order')">
                                            <el-tag style="height: 17px;line-height: 17px;padding: 0px 4px;cursor: pointer;">{{parseDay(fourCard.order.type)}}</el-tag>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="item.type" v-for="item of getOtherB(fourCard.order.type)">{{item.name}}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                        
                                    </div>
                                    <div class="cardBody">
                                        <div class="card_import">
                                            {{parseNums(fourCard.order.current,true)}}
                                        </div>
                                        <div class="card_icon color1">
                                            <svg-icon icon-class="tank" />
                                        </div>
                                    </div>
                                    <div class="cardFooter">
                                        <div class="top_title">总计划数: <span style="font-size: 1.2em">{{parseNums(fourCard.order.total,true)}}</span></div>
                                        <div class="total_number"></div>
                                    </div>
                                </div>
                          </el-popover>
                        </el-card>
                    </el-col>
                    <el-col :lg="6" :xs="12" class="topCard_view">
                        <el-card class="topCard" shadow="hover" v-loading="fourCard.weight.is_loading">
                            <el-popover
                                placement="top"
                                width="200"
                                trigger="hover"
                                >
                                <p>{{fourCard.weight.message}}</p>
                                <div slot="reference">
                                    <div class="cardHeader">
                                        <span class="top_title">装液量</span>
                                        <el-dropdown style="position: absolute;top: 10px;right: 15px" @command="handleCommand($event,'weight')">
                                            <el-tag style="height: 17px;line-height: 17px;padding: 0px 4px;cursor: pointer;">{{parseDay(fourCard.weight.type)}}</el-tag>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="item.type" v-for="item of getOtherB(fourCard.weight.type)">{{item.name}}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                    <div class="cardBody">
                                        <div class="card_import">
                                            {{parseNums(fourCard.weight.current)}} <span class="dw">吨</span>
                                        </div>
                                        <div class="card_icon color2">
                                            <svg-icon icon-class="water" />
                                        </div>
                                    </div>
                                    <div class="cardFooter">
                                        <div class="top_title">累计装液量: <span style="font-size: 1.2em">{{parseNums(fourCard.weight.total)}} 吨</span></div>
                                        <div class="total_number"></div>
                                    </div>
                                </div>
                            </el-popover>
                        </el-card>
                    </el-col>
                    <el-col :lg="6" :xs="12" class="topCard_view">
                        <el-card class="topCard" shadow="hover" v-loading="fourCard.money.is_loading">
                            <el-popover
                                placement="top"
                                width="200"
                                trigger="hover"
                                >
                                <p>{{fourCard.money.message}}</p>
                                <div slot="reference">
                                    <div class="cardHeader">
                                        <span class="top_title">销售额</span>
                                        <el-dropdown style="position: absolute;top: 10px;right: 15px" @command="handleCommand($event,'money')">
                                            <el-tag style="height: 17px;line-height: 17px;padding: 0px 4px;cursor: pointer;">{{parseDay(fourCard.money.type)}}</el-tag>
                                            <el-dropdown-menu slot="dropdown">
                                                <el-dropdown-item :command="item.type" v-for="item of getOtherB(fourCard.money.type)">{{item.name}}</el-dropdown-item>
                                            </el-dropdown-menu>
                                        </el-dropdown>
                                    </div>
                                    <div class="cardBody">
                                        <div class="card_import">
                                            {{parseNums(fourCard.money.current)}} <span class="dw">元</span>
                                        </div>
                                        <div class="card_icon color3">
                                            <svg-icon icon-class="money" />
                                        </div>
                                    </div>
                                    <div class="cardFooter">
                                        <div class="top_title">累计销售额: <span style="font-size: 1.2em">{{parseNums(fourCard.money.total)}}元</span></div>
                                        <div class="total_number"></div>
                                    </div>
                                </div>
                            </el-popover> 
                        </el-card>
                    </el-col>
                    <el-col :lg="6" :xs="12" class="topCard_view">
                        <el-card class="topCard" shadow="hover" v-loading="fourCard.price.is_loading">
                            <div class="cardHeader">
                                <span class="top_title">今日液价</span>
                            </div>
                            <div class="cardBody">
                                <div class="card_import">
                                    {{parseNums(fourCard.price.current)}} <span class="dw">元/吨</span>
                                </div>
                                <div class="card_icon color4">
                                    <svg-icon icon-class="price" />
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="12" :xs="24" class="chart_view">
                        <div>
                            <el-card class="chart_card">
                                <div class="chart-head">
                                    <ul class="chart-title">
                                        <li>今日计划</li>
                                    </ul>
                                    <ul class="chart-conter">
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{today.msgTotal}}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/jihuazongshu.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>计划总数：{{today.total}}</p>
                                        </li>
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{today.msgCurr }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/dangqianjihua.png" alt="">
                                                </div>
                                            </el-popover>
                                            <p>当前计划：{{today.curr}}</p>
                                        </li>
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{today.msgTodayComplate}}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/zuoriwancheng.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>今日完成：{{today.todayComplate}}</p>
                                        </li>
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{ today.msgAmComplate }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/zuoriwancheng.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>昨日完成：{{today.amComplate}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </el-card>
                        </div>
                        <el-card class="chart_view" style="height: 410px;position: relative" v-loading="today_orders.is_loading">
                            <today_orders style="width: 100%;height: 370px"></today_orders>
                        </el-card>
                    </el-col>
                    <el-col :lg="12" :xs="24" class="chart_view">
                          <div>
                            <el-card class="chart_card">
                                <div class="chart-head">
                                    <ul class="chart-title">
                                        <li>明日计划</li>
                                    </ul>
                                    <ul class="chart-conter">
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{ tomorow.totalMsg }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/leijishu.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>累计数：{{tomorow.total}}</p>
                                        </li>
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{ tomorow.currMsg }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/dangqianjihua.png" alt="">
                                                </div>
                                            </el-popover>
                                            <p>当前计划：{{tomorow.curr}}</p>
                                        </li>
                                        <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{ tomorow.unapprovedMsq }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/waishenhe.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>未审核：{{tomorow.unapproved}}</p>
                                        </li>
                                           <li>
                                            <el-popover
                                                placement="top"
                                                width="210"
                                                trigger="hover"
                                                >
                                                <p>{{ tomorow.approvedMsg }}</p>
                                                <div slot="reference">
                                                    <img src="../../../assets/img/yishenhe.jpg" alt="">
                                                </div>
                                            </el-popover>
                                            <p>已审核：{{tomorow.approved}}</p>
                                        </li>
                                    </ul>
                                </div>
                            </el-card>
                        </div>
                        <el-card class="chart_view" style="position: relative;height: 410px" v-loading="completion.is_loading">
                            <rate_charts style="width: 100%;height: 370px"/>
                        </el-card>
                    </el-col>
                    <el-col :span="24" class="chart_view">
                        <el-card class="chart_card">
                            <sales_charts style="width: 100%;height: 370px"></sales_charts>
                        </el-card>
                    </el-col>
                    <el-col :span="12" class="chart_view">
                        <el-card style="position: relative;">
                            <sales_charts1 style="width: 100%;height: 370px"></sales_charts1>
                        </el-card>
                    </el-col>
                    <el-col :span="12" class="chart_view">
                        <el-card>
                            <plan_charts style="width: 100%;height: 370px"></plan_charts>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
            <!--右边-->
            <el-col :lg="6" :sm="24">
                <el-card class="rightCard navCard">
                    <div slot="header" class="clearfix">
                        <span class="title_color">快捷导航</span>
                    </div>
                    <el-row>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:plan_index')">
                            <div class="icon pink_text" @click="goto('plan_index')"><svg-icon icon-class="plan" /></div>
                            <div class="text" @click="goto('plan_index')">当前计划单</div>
                        </el-col>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:plan_add')">
                            <div class="icon success_text" @click="goto('plan_add')"><svg-icon icon-class="add" /></div>
                            <div class="text" @click="goto('plan_add')">添加计划单</div>
                        </el-col>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:product_index')">
                            <div class="icon danger_text" @click="goto('product_index')"><svg-icon icon-class="pricem2" /></div>
                            <div class="text" @click="goto('product_index')">价格管理</div>
                        </el-col>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:customer_company')">
                            <div class="icon info_text"  @click="goto('customer_company')"><svg-icon icon-class="customer" /></div>
                            <div class="text"  @click="goto('customer_company')">企业管理</div>
                        </el-col>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:financial_procurement')">
                            <div class="icon primary_text" @click="goto('financial_procurement')"><svg-icon icon-class="permission" /></div>
                            <div class="text" @click="goto('financial_procurement')">采购计划</div>
                        </el-col>
                        <el-col :span="8" class="navBlock" v-if="has_permission('view:summary_table')">
                            <div class="icon warning_text" @click="goto('summary_table')"><svg-icon icon-class="report4" /></div>
                            <div class="text" @click="goto('summary_table')">汇总表</div>
                        </el-col>

                    </el-row>
                </el-card>
                <el-card class="rightCard taskCard">
                    <div slot="header" class="clearfix">
                         <el-popover
                            placement="top"
                            width="200"
                            trigger="hover"
                            >
                            <p>{{ this.weight_list.message }}</p>
                            <div slot="reference">
                                <span class="title_color">每日计划统计</span>
                                <!-- <el-button style="float: right; padding: 3px 0" type="text" v-if="weight_list.show_many" @click="showDialog('sales_rank')">更多</el-button> -->
                            </div>
                        </el-popover>
                    </div>
                    
                    <!-- <ul class="table-title">
                        <li style="width:25%">日期</li>
                        <li style="width:15%">计划数</li>
                        <li style="width:15%">装车数</li>
                        <li style="width:25%">装车量(吨)</li>
                        <li style="width:15%">装车率</li>
                    </ul> -->
                   <!-- <vue-seamless-scroll :data="weight_list.data"  class="auto-scorll-table" :class-option="optionSingleHeight"> -->
                        <el-table border :data="weight_list.data" class="custom-table-2 hidden-thead mytable_header_no">
                            <el-table-column label="日期" width="100" align="center">
                                <template slot-scope="scope">
                                    {{scope.row.planDate}}
                                </template>
                            </el-table-column>
                            <el-table-column label="计划数" width="80" align="center">
                                <template slot-scope="scope">
                                    {{scope.row.planCount}}
                                </template>
                            </el-table-column>
                            <el-table-column label="装车数" width="80" align="center">
                                <template slot-scope="scope">
                                    {{scope.row.completeCount}}
                                </template>
                            </el-table-column>
                            <el-table-column label="装车量(吨）" width="100" align="center">
                                <template slot-scope="scope">
                                    {{scope.row.netWeight}}
                                </template>
                            </el-table-column>
                            <el-table-column label="装车率" width="100" align="center">
                                <template slot-scope="scope">
                                    {{scope.row.completeRate}}
                                </template>
                            </el-table-column>
                        </el-table>
                   <!-- </vue-seamless-scroll> -->
                </el-card>
                <el-card class="rightCard taskCard cardheight">
                    <div slot="header" class="clearfix">
                        <span class="title_color">客户今年累计采购量排名</span>
                        <!-- <el-button style="float: right; padding: 3px 0" v-if="money_list.show_many" type="text" @click="showDialog('money_rank')">更多</el-button> -->
                    </div>
                     <!-- <ul class="table-title">
                        <li style="width:33%">客户简称</li>
                        <li style="width:33%">装车数</li>
                        <li style="width:34%">采购量(吨)</li>
                    </ul> -->
                    <el-table border :data="money_list.data" class="el-table top">
                        <el-table-column label="客户简称" min-width="36%" prop="abridge">
                        </el-table-column>
                        <el-table-column label="装车数" min-width="28%" prop="carNum">
                        </el-table-column>
                        <el-table-column label="采购量(吨)" min-width="36%" prop="weightSum">
                        </el-table-column>
                    </el-table>
                    <vue-seamless-scroll :data="money_list.data"  class="auto-scorll-table" :class-option="optionSingleHeight">
                        <el-table border :data="money_list.data" class="bottom" :show-header="false">
                            <el-table-column label="客户简称" min-width="36%" prop="abridge">
                            </el-table-column>
                            <el-table-column label="装车数" min-width="28%" prop="carNum">
                            </el-table-column>
                            <el-table-column label="采购量(吨)" min-width="36%" prop="weightSum">
                            </el-table-column>
                        </el-table>
                    </vue-seamless-scroll>
                </el-card>
                <!-- <el-card class="rightCard taskCard" v-loading="plan_list.is_loading">
                    <div slot="header" class="clearfix">
                        <span class="title_color">当月销售业绩完成情况</span>
                        <el-button style="float: right; padding: 3px 0" v-if="plan_list.show_many" type="text" @click="showDialog('plan_rank')">更多</el-button>
                    </div>
                    <el-table border :data="plan_list.data">
                        <el-table-column label="销售人员">
                            <template slot-scope="scope">
                                {{scope.row.uname}}
                            </template>
                        </el-table-column>
                        <el-table-column label="计划量(吨)">
                            <template slot-scope="scope">
                                {{scope.row.planNum}}
                            </template>
                        </el-table-column>
                        <el-table-column label="完成量(吨)">
                            <template slot-scope="scope">
                                {{scope.row.comNum}}
                            </template>
                        </el-table-column>
                        <el-table-column label="完成比(%)">
                            <template slot-scope="scope">
                                {{scope.row.comRate}} %
                            </template>
                        </el-table-column>
                    </el-table>
                </el-card> -->
            </el-col>
        </el-row>
        <el-row style="width: 100%" v-else-if="roles.length==0">
            <el-col :lg="24" :sm="24"></el-col>
        </el-row>
        <el-row style="width: 100%" v-else>
            <el-col :lg="24" :sm="24">
                <div class="client-bg">

                </div>
            </el-col>
        </el-row>
        <sales_rank ref="sales_rank"></sales_rank>
        <money_rank ref="money_rank"></money_rank>
        <plan_rank ref="plan_rank"></plan_rank>

    </el-container>
</template>

<script>
import {parseTime} from "@/utils";
import {mapGetters} from 'vuex'
import request from "@/utils/request"
import today_orders from '@/views/dashboard/admin/chart/today_orders'
import sales_charts from '@/views/dashboard/admin/chart/sales_charts'
import sales_charts1 from '@/views/dashboard/admin/chart/sales_charts1'
import plan_charts from "@/views/dashboard/admin/chart/plan_charts"
import rate_charts from '@/views/dashboard/admin/chart/rate_charts.vue'
import sales_rank from "./rank/sales_rank"
import money_rank from "./rank/money_rank"
import plan_rank from "./rank/plan_rank"
import message from '@/store/modules/message';



    export default {
        name: "DashboardAdmin",
        components:{
            today_orders,sales_charts,sales_charts1,plan_charts,sales_rank,money_rank,plan_rank,rate_charts
        },
        computed:{
            ...mapGetters([
                'userinfo',
                'roles',
                'permissions'
            ]),
            optionSingleHeight () {
                return {
                    step: 0.3, // 数值越大速度滚动越快
                    limitMoveNum: 16, // 最小的滚动行数，当数据条数大于此数时，就会滚动
                    hoverStop: true, // 是否开启鼠标悬停stop
                    direction: 1, // 0向下 1向上 2向左 3向右
                    openWatch: true, // 开启数据实时监控刷新dom
                    singleHeight: 55, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                    singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                    waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
                }
            },
            // optionSingleHeight() {
            //     return {
            //     singleHeight:55 // 这里要变成你的一行表格的高度 可以审查元素
            //     }
            // }
        },
        data() {
            return {
                is_ok:true,
                changePwdDialog:false,
                is_post:false,
                weight_list:{
                    show_many:false,
                    data:[],
                    is_loading:true
                },
                is_weight:false,
                money_list:{
                    data:[],
                    show_many:false,
                    is_loading:true
                },
                is_money:false,
                plan_list:{
                    data:[],
                    show_many:false,
                    is_loading:true
                },
                is_plan:false,

                customColors:[
                    {color: '#909399', percentage: 20},
                    {color: '#F56C6C', percentage: 40},
                    {color: '#E6A23C', percentage: 60},
                    {color: '#409EFF', percentage: 80},
                    {color: '#67C23A', percentage: 100}
                ],
                timeRange:[],
                fourCard:{
                    order:{
                        current:32,
                        total:1230,
                        type:"day", //day|month|year
                        is_loading:false,
                        message:'',
                    },
                    weight:{
                        current:9873092,
                        total:130230,
                        type:"day",
                        is_loading:false,
                        message:'',
                    },
                    money:{
                        current:98092,
                        total:1330,
                        type:"day",
                        is_loading:false,
                        message:''
                    },
                    price:{
                        current:3700.05,
                        is_loading:false,
                        message:''
                    }
                },
                completion:{
                    month:{
                        plan:0,
                        com:0,
                        rate:0,
                        is_null:true
                    },
                    year:{
                        plan:0,
                        com:0,
                        rate:0,
                        is_null:true
                    },
                    is_loading:true,
                },
                today_orders:{
                    data:[],
                    is_loading:true,
                    is_null:true
                },
                //今日，明日计划
                today:{},
                tomorow:{},
                beforeDateTime:'',
                dayTime:'',
                tomorrowTime:'',
            }
        },
        methods: {
            async fetchData() {
                const resstep2 = await getLatestBlocksInfoJsonStr()
                let jsonlist = JSON.parse(resstep2.data.blockHeight)
                this.weight_list.data = jsonlist

            },
            getOtherB(type){
                if(type == "day"){
                    return [{type:"month",name:"本月"},{type:"year",name:"本年"}];
                }else if(type == "month"){
                    return [{type:"day",name:"当日"},{type:"year",name:"本年"}];
                }else{
                    return [{type:"day",name:"当日"},{type:"month",name:"本月"}];
                }
            },
            getCurrenTime(){
                //获取当前时间
                var date = new Date();
                var year = date.getFullYear().toString();
                var month = (date.getMonth() + 1).toString();
                var beforeDay=(date.getDate()-1).toString();
                var day = date.getDate().toString();
                var tomorrow = (date.getDate()+1).toString();
                var hour = date.getHours().toString();
                var minute =  date.getMinutes().toString();
                var second = date.getSeconds().toString();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (day >= 0 && day <= 9) {
                    day = "0" + day;
                }
                if (beforeDay >= 0 && beforeDay <= 9) {
                    beforeDay = "0" + beforeDay;
                }
                if (tomorrow >= 0 && tomorrow <= 9) {
                    tomorrow = "0" + tomorrow;
                }
                if(hour <10){
                    hour = "0" + hour;
                }
                if(minute <10){
                    minute = "0" + minute;
                }
                if(second <10){
                    second = "0" + second ;
                }
                if(hour<8){
                    this.dayTime = month+'月' + beforeDay+'日';
                    this.tomorrowTime = month+'月' + day+'日';
                }else{
                    this.dayTime = month+'月' + day+'日';
                    this.tomorrowTime = month+'月' + tomorrow+'日';
                }
                this.beforeDateTime = month+'月' + beforeDay+'日';
            },
            parseDay(type){
                if(type == "day"){
                    return "当日";
                }else if(type == "month"){
                    return "本月";
                }else {
                    return "本年";
                }
            },
            //更改
            handleCommand(command,item){
                this.fourCard[item].is_loading = true;
                let mode = 0;
                if(command == "month"){
                    mode = 1;
                }else if(command == "year"){
                    mode = 2;
                }
                let url = "index/plan_count";
                if(item == "weight"){
                    url = "index/load_weight";
                }else if(item == "money"){
                    url = "index/sale_amount";
                }
                request.get(`${url}?mode=${mode}`).then(res=>{
                    if(item == "order"){
                        this.fourCard[item].current = res.data.count;
                        this.fourCard[item].total = res.data.allCount;
                    }else if(item == "weight"){
                        this.fourCard[item].current = res.data.weight;
                        this.fourCard[item].total = res.data.allLoadWeight;
                    }else if(item == "money"){
                        this.fourCard[item].current = res.data.saleAmount;
                        this.fourCard[item].total = res.data.allSaleAmount;
                    }
                    this.fourCard[item].is_loading = false;
                }).catch(err=>{
                    this.fourCard[item].is_loading = false;
                });
                this.fourCard[item].type = command;
            },
            parseTime(time){
                return parseTime(time,"{y}-{m}-{d} {h}:{i}:{s}");
            },
            has_permission(permission){
                return this.permissions.includes(permission);
            },
            getPosition: (obj) => {
                return [ obj.question, 0 ];
            },
            getContent: (obj) => {
                return obj.question + ' ';
            },
            goto(name){
                this.$router.push({name:name});
            },
            parseNums(n,is_int=false) {
                //转化成字符串
                let str = n.toString();
                //若是整数自动补全小数位
                if (-1 == str.indexOf(".")) {
                    str = str + ".00"
                }
                if(str.indexOf(".")!=-1){
                    let x = str.indexOf('.') + 1;   //小数点的位置
                    let y = str.length - x;  //小数的位数
                    if(y > 0 && y == 1){
                        str = str + "0"
                    }
                }
                //全部替换
                if (-1 != str.indexOf(",")) {
                    str = str.replace(new RegExp(',', "g"), "")
                }
                let intSum = str.substring(0, str.indexOf(".")).replace(/\B(?=(?:\d{3})+$)/g, ',');//取到整数部分
                if(is_int){
                    return intSum;
                }
                let dot = str.substring(str.length, str.indexOf("."))//取到小数部分搜索
                let ret = intSum + dot;
                return ret;
            },
            showDialog(type){
                this.$refs[type].showMany();
            },
            getFourData(){
                request.get("index/plan_count?mode=0").then(res=>{
                    this.fourCard.order.current = res.data.count;
                    this.fourCard.order.total = res.data.allCount;
                    this.fourCard.order.is_loading = false;
                    this.fourCard.order.message = res.data.message;
                }).catch(err=>{
                    this.fourCard.order.is_loading = false;
                });
                request.get("index/load_weight?mode=0").then(res=>{
                    this.fourCard.weight.current = res.data.weight;
                    this.fourCard.weight.total = res.data.allLoadWeight;
                    this.fourCard.weight.is_loading = false;
                    this.fourCard.weight.message = res.data.message;
                }).catch(err=>{
                    this.fourCard.weight.is_loading = false;
                });
                request.get("index/sale_amount?mode=0").then(res=>{
                    this.fourCard.money.current = res.data.saleAmount;
                    this.fourCard.money.total = res.data.allSaleAmount;
                    this.fourCard.money.is_loading = false;
                    this.fourCard.money.message = res.data.message;
                }).catch(err=>{
                    this.fourCard.money.is_loading = false;
                });
                request.get("index/today_price").then(res=>{
                    this.fourCard.price.current = res.data.todayPrice;
                    this.fourCard.price.is_loading = false;
                }).catch(err=>{
                    this.fourCard.price.is_loading = false;
                });
            },
            get_today_plans(){
                request.get("index/today_plan_status").then(res=>{
                    this.today_orders.data = res.data;
                    if(res.data.every(i=>i == 0)){
                        this.today_orders.is_null = true;
                    }else {
                        this.today_orders.is_null = false;
                    }
                    this.today_orders.is_loading = false;
                }).catch(err=>{
                    this.today_orders.is_loading = false;
                });
            },
            get_complete(){
                request.get("index/figure_complete_rate").then(res=>{
                    this.completion.month.com = res.data.monthComplete;
                    this.completion.month.plan = res.data.monthPlan;
                    this.completion.month.rate = res.data.monthCompleteRate;
                    if(res.data.monthPlan == 0){
                        this.completion.month.is_null = true;
                    }else{
                        this.completion.month.is_null = false;
                    }
                    this.completion.year.com = res.data.yearComplete;
                    this.completion.year.rate = res.data.yearCompleteRate;
                    this.completion.year.plan = res.data.yearPlan;
                    if(res.data.yearPlan == 0){
                        this.completion.year.is_null = true;
                    }else{
                        this.completion.year.is_null = false;
                    }
                    this.completion.is_loading = false;
                }).catch(err=>{
                    this.completion.is_loading = false;
                });
            },
            get_weight_list(){
                request.get("index/everyday_plan_count").then(res=>{
                    this.weight_list.data = res.data;
                    this.weight_list.message = res.msg;
                }).catch(err=>{
                    this.weight_list.is_loading = false;
                });
            },
            get_money_list(){
                request.post("index/year_purchase_ranking",{pageSize:5,pageNum:1}).then(res=>{
                    this.money_list.data = res.data;
                    // if(res.data.total <= 5){
                    //     this.money_list.show_many = false;
                    // }else{
                    //     this.money_list.show_many = true;
                    // }
                    this.money_list.is_loading = false;
                }).catch(err=>{
                    this.money_list.is_loading = false;
                });
            },
            get_plan_list(){
                request.post("index/seller_figure_complete_ranking",{pageSize:5,pageNum:1}).then(res=>{
                    this.plan_list.data = res.data.list;
                    if(res.data.total <= 5){
                        this.plan_list.show_many = false;
                    }else{
                        this.plan_list.show_many = true;
                    }
                    this.plan_list.is_loading = false;
                }).catch(err=>{
                    this.plan_list.is_loading = false;
                });
            },
            //看见这代码，脑瓜子。。。。眼睛闭住了

            //什么鬼操作，我要减肥

            //今日计划和明日计划
            dayTomorrow(){
                //今日计划
                request.get('index/today_count').then(res=>{
                    if(res.code==200){
                        this.today=res.data
                    }else{
                        this.$message.error(res.msg)
                    }
                })
                //明日计划哦
                request.get('index/tomorrow_count').then(res=>{
                    if(res.code==200){
                        this.tomorow=res.data
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            this.getCurrenTime();
            this.getFourData();
            this.get_today_plans();
            this.dayTomorrow();
            this.get_complete();
            this.get_weight_list();
            this.get_money_list();
            this.get_plan_list();
        }
    }
</script>

<style scoped lang="scss">
@import "@/styles/element-variables.scss";
    .client-bg {
        padding: 0;
        margin: 0;
        background-image: url("../../../assets/img/clientbg.jpg");
        background-color: #f0f2f5;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 84vh;
    }
    .chart-conter{
        display:flex;
        justify-content:space-between;
    }
    .chart-title{
        font-size: 18px;
        color: #666;
    }
    .chart-conter li div{
        margin:16px 0;
        text-align:center;
    }
    .chart-conter li div img{
        width:32px;
        height:32px;
    }
    .auto-scorll-table {
        height:700px;
        overflow: hidden;
    }
    .table-title{
        display:flex;
        justify-content:space-around;
    }
.topCard_view{
    padding: 0px 10px 10px 0px;
    height: 150px;
    position: relative;
    &:nth-child(1){
        padding-left: 0;
    }
    .topCard {
        width: 100%;
        height: 100%;
        background: #ffffff;
        border: none;
        border-radius: 3px;
        position: relative;


        .cardHeader{
            display: flex;
            align-items: start;
            justify-content: space-between;
            height: 20px;
            line-height: 20px;
            .top_title{
                font-size: 14px;
                color: #95aac9;
            }
        }
        .cardBody{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 70px;
            .card_import{
                font-size: 20px;
                font-weight: 500;
                letter-spacing:0.5px;
                color: #666;
                margin-left: 10px;
                .dw{
                    font-size: 14px;
                }
            }
            .card_icon{
                $icon-block-weight:50px;
                font-size: 30px;
                font-weight: 500;
                height: $icon-block-weight;
                width: $icon-block-weight;
                //background: #b8c2cc;
                text-align: center;
                line-height: $icon-block-weight;
                border-radius: 15px;
                color: #7367f0;
                transition: all .5s;
                &:hover{
                    color:#fff;
                    background:#7367f0;
                }
                &.color2{
                    color:#00cfe8;
                    &:hover{
                        color:#fff;
                        background:#00cfe8;
                    }
                }
                &.color3{
                    color: #409EFF;
                    &:hover{
                        color:#fff;
                        background:#409EFF;
                    }
                }
                &.color4{
                    color:#F56C6C;
                    &:hover{
                        color:#fff;
                        background:#F56C6C;
                    }
                }
            }
            border-bottom: 1px solid #eee;
        }
        .cardFooter{
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 30px;
            .top_title{
                font-size: 12px;
                color: #95aac9;
            }
        }

        .tagBtn{
            position: absolute;
            top: 14px;
            right: 15px;
            height: 17px;
            line-height: 17px;
            padding: 0px 4px;
            cursor: pointer;
        }

        &:nth-child(1){
            width: calc(100% - 10px);
        }
    }
}
.cardheight{
    height:843px;
    overflow-y: auto;
    margin-top: 31px;
}
.rightCard{
    margin-bottom: 23px;
    .navBlock{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        height: 90px;
        .icon{
            font-size: 25px;
            margin-bottom: 10px;
            width: 100%;
            text-align: center;
        }
        .text{
            width: 100%;
            text-align: center;
            font-size: 15px;
        }
        transition: all .3s;
        cursor: pointer;
        &:hover{
            box-shadow: 0 0 4px #aaa;
        }
        &:nth-child(1){
            $block-border:1px solid #e6ebf5;
            border-right: $block-border;
            border-bottom: $block-border;
        }
        &:nth-child(2){
            $block-border:1px solid #e6ebf5;
            border-right: $block-border;
            border-bottom: $block-border;
        }
        &:nth-child(3){
            $block-border:1px solid #e6ebf5;
            border-bottom: $block-border;
        }
        &:nth-child(4){
            $block-border:1px solid #e6ebf5;
            border-right: $block-border;
        }
        &:nth-child(5){
            $block-border:1px solid #e6ebf5;
            border-right: $block-border;
        }
    }
}
.chart_view{
    margin: 10px 0;
    padding-right: 20px;
}

.year_ratio{
    position: relative;
    top: 20%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction:column;
    div{
        margin-bottom: 10px;
    }
}
.year_ratio_title{
    font-size: 18px;
    color: #666;
    display: block;
    position: absolute;
    top: 20px;
    left: 22px;
}

.title_color{
    color:#95aac9;
}

.sale_chart_time_range{
    position: absolute;
    top: 20px;
    right: 20px;
}
.bottom{
  height: 98%;
}
.top ::v-deep .el-table__body-wrapper{
    display:none !important;
}
</style>
